export default "__VITE_ASSET__O1eQVNbS__"